import { render, staticRenderFns } from "./AddMaterialInward.vue?vue&type=template&id=37fe962c"
import script from "./AddMaterialInward.vue?vue&type=script&lang=js"
export * from "./AddMaterialInward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports